import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#language_svg__a)" }, [
      _createElementVNode("path", {
        "fill-rule": "evenodd",
        d: "M7.7.06a7.96 7.96 0 1 1 .6 15.9A7.96 7.96 0 0 1 7.7.06Zm2.1 14.13a6.45 6.45 0 0 0 3.83-3.04h-2.77a14.35 14.35 0 0 1-1.05 3.04Zm-.48-3.04A12.85 12.85 0 0 1 8 14.41a12.85 12.85 0 0 1-1.32-3.26h2.64Zm1.8-1.5h3.12a6.45 6.45 0 0 0 0-3.3h-3.12a14.37 14.37 0 0 1 0 3.3ZM9.6 6.35a12.85 12.85 0 0 1 0 3.3H6.39a12.85 12.85 0 0 1 0-3.3h3.22Zm1.25-1.5h2.77A6.45 6.45 0 0 0 9.8 1.81c.46.97.82 2 1.05 3.04Zm-1.54 0H6.68c.29-1.14.73-2.23 1.32-3.26a12.85 12.85 0 0 1 1.32 3.26ZM6.19 1.81a6.45 6.45 0 0 0-3.82 3.04h2.77a14.2 14.2 0 0 1 1.05-3.04ZM4.9 6.35H1.75a6.45 6.45 0 0 0 0 3.3h3.12a14.35 14.35 0 0 1 0-3.3Zm.25 4.8a14.2 14.2 0 0 0 1.05 3.04 6.45 6.45 0 0 1-3.82-3.04h2.77Z",
        "clip-rule": "evenodd"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "language_svg__a" }, [
        _createElementVNode("path", { d: "M0 0h16v16H0z" })
      ])
    ], -1)
  ])))
}
export default { render: render }